import styled from 'styled-components';
import { themeGet, getTextColor, getBorderColor, getMediaQuery } from '@magalu/stereo-ui-styles';
import Box from '../../atoms/Box';
import Text from '../../atoms/Text';
export const Container = styled.div`
  ${getMediaQuery('large')} {
    display: flex;
  }
`;
export const TitleName = styled(Text)`
  margin-top: 4px;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet(props.bold ? 'fontWeights.medium' : 'fontWeights.regular')(props)};
  color: ${props => getTextColor('base')(props)};

  > span {
    color: ${props => getTextColor('lighter')(props)};
  }
`;
export const TitleReview = styled(Text)`
  margin-top: 12px;
  font-size: ${props => themeGet('fontSizes.5')(props)}px;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  color: ${props => getTextColor('base')(props)};
  line-height: ${props => themeGet('lineHeights.display')(props)};
`;
export const Description = styled(Text)`
  margin: 12px 0;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  color: ${props => getTextColor('scratched')(props)};
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;
  text-align: justify;
`;
export const Divider = styled(Box)`
  border-bottom: 3px solid ${props => getBorderColor('light')(props)};
  margin: 16px 0px;
  width: 100%;
`;
export const Recommended = styled(Text)`
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};

  color: ${props => props.reviewOK ? themeGet('baseColors.lima.base')(props) : themeGet('baseColors.vermillion.base')(props)};
`;
export const ContainerReview = styled(Box)`
  ${getMediaQuery('large')} {
    width: 50%;
    flex: 1;
    margin-right: 32px;
  }
`;
export const ContainerReviewCharacteristics = styled(Box)`
  ${getMediaQuery('large')} {
    align-self: center;
    width: 50%;
  }
`;